import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { alpha, Box } from '@mui/material'

import { BACKDROP_BLUR, BACKDROP_OPACITY, BACKDROP_Z_INDEX } from '../constants'

interface SidebarBackdropProps {
  readonly visible: boolean
  readonly onClick: () => void
}

export const SidebarBackdrop: FC<SidebarBackdropProps> = ({ visible, onClick }) => {
  if (!visible) return null

  return <Box onClick={onClick} sx={backdropSx} aria-hidden="true" />
}

const backdropSx: SxProps<Theme> = (theme) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: alpha(theme.palette.mode === 'dark' ? '#000000' : '#3E2723', BACKDROP_OPACITY),
  backdropFilter: `blur(${BACKDROP_BLUR})`,
  zIndex: BACKDROP_Z_INDEX,
  animation: 'fadeIn 200ms ease-out',
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
})
